import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guard/auth.guard';

const accountRoutes: Routes = [
    { path: 'account/profile',      loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule),
        canActivate: [AuthGuard] },
    { path: 'account/affiliate',    loadChildren: () => import('./affiliate/affiliate.module').then(m => m.AffiliatePageModule),
        canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(accountRoutes)],
    exports: [RouterModule]
})
export class AccountRoutingModule {
}
